import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CampaignSetOwner as CampaignSetOwnerMutation,
    CampaignSetOwnerVariables as CampaignSetOwnerMutationVariables,
} from 'nutshell-graphql-types';

import CAMPAIGN_SET_OWNER from '../mutations/campaign-set-owner.graphql';

export function useCampaignSetOwner(): {
    setOwner: (arg1: {campaignId: string; userId: string | null | undefined}) => Promise<any>;
    errorMessage: string | null | undefined;
    isLoading: boolean;
} {
    const [setOwner, {error, loading}] = useMutation<
        CampaignSetOwnerMutation,
        CampaignSetOwnerMutationVariables
    >(CAMPAIGN_SET_OWNER);

    return {
        setOwner: (input: {campaignId: string; userId: string | null | undefined}) => {
            const {campaignId, userId} = input;

            return setOwner({
                variables: {
                    input: {
                        campaignId,
                        userId,
                    },
                },
            });
        },
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
}
